import { makeVar } from '@apollo/client'

import { IUser } from 'pared/data/getUserByEmail'

export const decodedUserJwtToken = makeVar<any>(null)
export const userProfile = makeVar<IUser>({})
